module.exports = __webpack_public_path__ + "img/eductor_stopped.fc91598b.svg";